import { motion } from "framer-motion";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

export const Section1 = () => {
  const isMobile = useResponsiveMobile(900);
  return (
    <div className="flex w-full flex-col justify-between items-center md:px-[100px]">
      <div className="flex flex-col md:flex-col  lg:flex-row justify-between max-w-[1440px] w-full items-center px-6 md:px-0 gap-20 md:gap-20 lg:gap-0">
        {/* 왼쪽 텍스트 */}
        <motion.div
          className="flex flex-col gap-3"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ amount: 0.45, once: true }} // 화면 중간쯤 닿았을 때
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-center  lg:text-left font-normal text-[18px] text-[#0079FF]">
            협력사와 이용사례
          </span>
          <div className="flex flex-col gap-[32px] md:gap-6">
            <span className="text-center lg:text-left font-bold text-[36px] md:text-display">
              품과 함께한 <br /> 파트너 성공 사례
            </span>
            <span className="text-center lg:text-left text-[18px] md:text-heading1 font-normal text-[#4D4F58]">
              정산·결제·영업대행 관리까지 통합 솔루션으로 {isMobile ? <br /> : ""}
              {!isMobile ? <br /> : ""}
              업무 효율과 투명성을 높인 실제 사례를 {isMobile ? <br /> : ""}
              소개합니다.
            </span>
          </div>
        </motion.div>

        {/* 오른쪽 이미지 */}
        <motion.img
          src="/assets/images/case/eg1.png"
          alt=""
          className="rounded-[24px] md:max-w-[561px]"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ amount: 0.45, once: true }}
          transition={{
            duration: 0.75,
            delay: 0.08,
            ease: [0.22, 1, 0.36, 1],
          }}
        />
      </div>
    </div>
  );
};
